export class ServiceVirtualReceptionEntity {
  service_id: any;
  indial_number: any;
  connection_type: any;
  greeting_business_name: any;
  greeting_type: any = "";
  greeting_message: any;
  config_module: any;
  greeting_message_ah: any;
  greeting_message_bh: any;
  personalised_sign_off: any;
  email_subject_prefix: any;
  sms_prefix: any;
  indial_city: any;
  info_contact_name: any;
  info_phone_number: any;
  info_fax: any;
  info_website: any;
  info_address: any;
  info_other_trading_name: any;
  info_industry_description: any;
  info_business_hours: any;
  business_hour_from: any;
  business_hour_to: any;
  info_trading_days: any;
  comment: any;
  connection_list: any=[];
  additional_questions: any=[];
  additional_departments: any=[];
  middle_script: any;
  middle_script_ah: any;
  middle_script_bh: any;
  cancellation_date: any = "";
  cancellation_reason: any;
  service_specific_notes: any;
  service_status: any;
  status: any;
  sign_off_type:any;
  caller_surname: any;
  caller_hung_up: any;
  clear_clid: any;
  enquiry_text_label: any;
  nature_of_call_label: any;
  sms_format: any;
}